import React, { createContext, useContext, useState } from "react";

const DICT = {
  en: {
    home: "Home", services: "Services", gallery: "Gallery", build: "Build Your Menu",
    about: "About & Contact", quote: "Get a Quote",
    heroBadge: "Roha · Raigad · 402116",
    heroTitle: "Catering that turns gatherings into celebrations",
    heroSub: "Authentic Maharashtrian & Indian menus, elegantly served. Design your own thali, katori by katori.",
    buildCta: "Build Your Menu",
    years: "Years catering", events: "Events served", guests: "Happy guests",
    explore: "Explore", reachUs: "Reach Us", rights: "All rights reserved.", poweredBy: "Powered by",
    yourThali: "Your Thali", list: "List", plate: "Plate", clear: "Clear",
    centre: "Centre", rice: "Rice", bhakri: "Bhakri",
    dietary: "Dietary", veg: "Veg", jain: "Jain",
    occasion: "Occasion", guestCount: "Guest count", quickStart: "Quick start preset",
  },
  mr: {
    home: "मुख्यपृष्ठ", services: "सेवा", gallery: "गॅलरी", build: "मेनू तयार करा",
    about: "आमच्याबद्दल / संपर्क", quote: "कोट मिळवा",
    heroBadge: "रोहा · रायगड · ४०२११६",
    heroTitle: "परंपरेचा स्वाद, मनापासूनचा पाहुणचार",
    heroSub: "अस्सल महाराष्ट्रीयन व भारतीय मेनू, रुचकर सादरीकरणासह. आपलं ताट स्वतः तयार करा — वाटी वाटीने.",
    buildCta: "मेनू तयार करा",
    years: "वर्षांचा अनुभव", events: "कार्यक्रम पूर्ण", guests: "आनंदी पाहुणे",
    explore: "शोधा", reachUs: "संपर्क", rights: "सर्व हक्क राखीव.", poweredBy: "द्वारा समर्थित",
    yourThali: "तुमचं ताट", list: "यादी", plate: "ताट", clear: "साफ करा",
    centre: "मध्यभागी", rice: "भात", bhakri: "भाकरी",
    dietary: "आहार", veg: "शाकाहारी", jain: "जैन",
    occasion: "प्रसंग", guestCount: "पाहुणे संख्या", quickStart: "झटपट मेनू",
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("mc_lang") || "en");
  const setLang = (l) => { localStorage.setItem("mc_lang", l); setLangState(l); };
  const t = (k) => (DICT[lang] && DICT[lang][k]) || DICT.en[k] || k;
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
